import { memberApiV2 } from '../lib/api';

import { IGetProgramsParams, ProgramData } from '../types/programs';

export function getPrograms(providerId: string, id: string) {
  return memberApiV2.request<{ data: ProgramData[] }>('/management/private/tools', {
    method: 'GET',
    params: {
      clientId: id,
    },
    headers: {
      'provider-id': providerId,
    },
  });
}
